
function get_project(type_string){
    var data, url, type_title
    $('#project_name_list').html('<div class="spinner-border text-danger" role="status"> <span class="sr-only">Loading...</span> </div>');
    $('#project_description').html('<div class="spinner-border text-danger" role="status"> <span class="sr-only">Loading...</span> </div>');
    if (type_string == "ALL") {
        url = publicPath + '/napi/emis/project?query_condition=ALL'
        type_title = ""
    } else {
        url = publicPath + '/napi/emis/project?query_condition=' + type_string
        type_title = type_string
    }
    ajax_call_async(url, 
        function(rawData){
            var filterData = rawData.filter(el => {
                return el.SpecialSee !== true
            })
            $('#project_name_list').empty();
            $('#project_description').empty();
            data = filterData
            create_project_list(filterData);
            $('#project_submit').attr('disabled', false)
        },
        function(){
            toast_open("EMIS資料庫介接異常！")
            $('#project_name_list').html('<div class="text-center"><i class="fas fa-exclamation mr-2"></i>EMIS資料庫介接異常，<br>無法選擇專案。</div>');
            $('#project_description').html('<div class="text-center"><i class="fas fa-exclamation mr-2"></i>EMIS資料庫介接異常，<br>無法檢視專案資訊。</div>');
            $('#project_submit').attr('disabled', true)
        }
    );

    $("#project_name_filter").keyup(function(){
        var data_filter = [];
        $('#project_name_list').empty();
        $('#project_description').empty();
        var input = $(this).val();
        if (input == "") {
            create_project_list(data);
        } else {
            data.forEach(function(element){
                if(element.PRJ_NAME.match(input) != null){
                    data_filter.push(element);
                };
            })
        }
        create_project_list(data_filter);
    });
    
    function create_project_list(data){
        var project_name_list_html = '', project_description_html = ''
        $.each(data, function(index, element) {
            var head1 = '<a class="list-group-item list-group-item-action" data-toggle="list" eoc-type="' + type_string + '" href="#',
                head2 = '<div class="tab-pane fade show" id="',
                number = index + 1,
                endTimeString
            // first item active
            if (index === 0) {
                head1 = '<a class="list-group-item list-group-item-action active" data-toggle="list" eoc-type="' + type_string + '" href="#';
                head2 = '<div class="tab-pane fade show active" id="';
            }
            if (element['CLOSE_TIME'] == null) {
                endTimeString = null_Converter_v2(element['CLOSE_TIME'])
            } else {
                endTimeString = timeConverter(element['CLOSE_TIME'])
            }
            project_name_list_html = 
                project_name_list_html + head1 + element['PRJ_ID'] + '" role="tab">' + 
                type_title + '應變中心編號：' + number + '<br>' +
                '年度：' + String(element['CREATE_TIME']).slice(0,4) + '<br>' +
                '<span level="'+ element['EMC_LEVEL'] +'" status="'+ element['OPENCLOSE'] +'" now="' + element['CREATE_TIME'] + '" close="' + element['CLOSE_TIME'] + '">' + 
                element['PRJ_NAME'] + '</span></a>';
            // project type
            switch (true) {
                case (element['PRJ_NAME'].match("颱風") != null):
                    element['PRJ_TYPE_STRING'] = '風災'
                    break
                case (element['PRJ_NAME'].match("強降雨") != null):
                case (element['PRJ_NAME'].match("大雨") != null):
                    element['PRJ_TYPE_STRING'] = '大雨'
                    break
                case (element['PRJ_NAME'].match("地震初期巡檢") != null):
                    element['PRJ_TYPE_STRING'] = '地震初期巡檢'
                    break
                case (element['PRJ_NAME'].match("地震") != null):
                    element['PRJ_TYPE_STRING'] = '地震'
                    break
                default:
                    element['PRJ_TYPE_STRING'] = '其它'
            }
            // html
            project_description_html = project_description_html +
                head2 + element['PRJ_ID'] + '" role="tabpanel">'  +
                '<h3 class="font-weight-bold">專案名稱：' + element['PRJ_NAME'] + '</h3>' +
                '災害種類：<span class="eoc_type">' + element['PRJ_TYPE_STRING'] + '</span>' +
                '<br>建立時間：' + timeConverter(element['CREATE_TIME']) +
                '<br>關閉時間：' + endTimeString +
                '<br>目前指揮官名稱：' + null_Converter_v2(element['CMDR']) +
                '<br>目前層級：' + null_Converter_v2(element['EMC_LEVEL']) + '級'  +
                '<br>目前狀態：' + null_Converter_v2(element['OPENCLOSE']) +
                '<br>專案描述：' + element['SITU']  +
                '<br>備註說明：' + null_Converter_v2(element['MEMO'])  +
                '<br>開設歷程：' + null_Converter_v2(element['HIST'])  +
                '</div>'
        });
        $('#project_name_list').append(project_name_list_html);
        $('#project_description').append(project_description_html);
    }
}

var emisBtnList = ["t_initial"],
    event_updater = undefined,
    board_updater = undefined;

function board_updater_control(project_id_query){
    var now_time_object = new Date();
    var min = now_time_object.getMinutes();
    var sec = now_time_object.getSeconds();
    var min_logical = (min % 5 == 0);
    var sec_logical = (sec == 0);
    if (min_logical && sec_logical) {
        loader_asynchronous(function(){
            board_info_initial(project_id_query);
        });
    }
}

function submit_project(){
    if ($('#select_project_type').val() == 'ALL') {
        let type = $("#project_description").children(".active").children('.eoc_type').text()
        if (type == '風災') { type = '颱風' }
        $('#select_scenario_type').val(type + '情境')
    }
    
    $('#scenario_content').empty()
    $('#scenario_content').parent('.ui-dialog').remove()
    $('#scenario_close').remove()
    $("#toggle_scenario_modal").off('click')
    const make_scenario_content = () => {
        var steps, advanced_steps
        switch ($("#select_scenario_type").val()) {
            case '強降雨(大雨)情境':
                steps = [
                    { title:'查看「<b id="open_rain">預警監控_降雨動態</b>」', content:[] },
                    { title:'查看「<b id="open_alarm">預警監控_監測示警</b>」', content: [
                        'scenario_content_rain', 'scenario_content_flood', 
                        'scenario_content_pump_station', 'scenario_content_pump_moving'] },
                    { title:'查看「<b id="open_water">強降雨應變機制</b>」', content:[] },
                    { title:'查看「<b id="open_cctv">預警監控_CCTV</b>」', content:[] },
                    { title:'通報相關單位', content:[] }
                ]
                advanced_steps = [
                    { title:'查看「<b id="open_rain_predict">災情預測_降雨預測模組</b>」', content:[] },
                    { title:'查看「<b id="open_thundershower_predict">災情預測_午後雷陣雨預測模組</b>」', content:[] },
                    { title:'查看「<b id="open_flood_predict">災情預測_地面淹水預測&抽水機調度模組</b>」', content:[] },
                    { title:'查看「<b id="open_hillslope_predict">災情預測_坡地預測模組</b>」', content:[] },
                    { title:'查看「<b id="open_power_failure_map">災情預測_颱洪停電風險地圖</b>」', content:[] }
                ]
                break;
            case '颱風情境':
                steps = [
                    { title:'查看「<b id="open_typhoon">預警監控_颱風動向</b>」', content:[] },
                    { title:'查看「<b id="open_rain">預警監控_降雨動態</b>」', content:[] },
                    { title:'查看「<b id="open_alarm">預警監控_監測示警</b>」', content: [
                        'scenario_content_rain', 'scenario_content_flood', 
                        'scenario_content_pump_station', 'scenario_content_pump_moving'] },
                    { title:'查看「<b id="open_cctv">預警監控_CCTV</b>」', content:[] },
                    { title:'通報相關單位', content:[] }
                ]
                advanced_steps = [
                    { title:'查看「<b id="open_rain_predict">災情預測_降雨預測模組</b>」', content:[] },
                    { title:'查看「<b id="open_thundershower_predict">災情預測_午後雷陣雨預測模組</b>」', content:[] },
                    { title:'查看「<b id="open_flood_predict">災情預測_地面淹水預測&抽水機調度模組</b>」', content:[] },
                    { title:'查看「<b id="open_hillslope_predict">災情預測_坡地預測模組</b>」', content:[] }
                ]
                break;
            case '土石流情境':
                steps = [
                    { title:'查看「<b id="open_alarm_debris">預警監控_監測示警</b>」', content: ['scenario_content_debris'] },
                    { title:'查看「<b id="open_debris">預警監控_山坡地社區</b>」', content:[] },
                    { title:'查看「<b id="open_cctv">預警監控_CCTV</b>」', content:[] },
                    { title:'通報相關單位', content:[] }
                ]
                advanced_steps = [
                    { title:'查看「<b id="open_hillslope_predict">災情預測_坡地預測模組</b>」', content:[] }
                ]
                break;
            case '地震情境':
                steps = [
                    { title:'查看「<b id="open_earthquake">預警監控_地震監控</b>」', content: ['scenario_content_earthquake'] },
                    { title:'查看「<b id="open_key_analysis">關鍵區位分析_重大優先巡檢</b>」', content:[] },
                    { title:'查看「<b id="open_1click">一鍵通</b>」', content:[] },
                    { title:'查看「<b id="open_cctv">預警監控_CCTV</b>」', content:[] },
                    { title:'通報相關單位', content:[] }
                ]
                advanced_steps = []
                break;
            case '火災情境':
                steps = [
                    { title:'查看「<b id="open_fire">預警監控_火災風險</b>」', content: ['scenario_content_fire'] },
                    { title:'查看「狹小巷道火災搶救不易地區」', content:[] },
                    { title:'查看「高危險建築物-點位圖」', content:[] },
                    { title:'查看「<b id="open_cctv">預警監控_CCTV</b>」', content:[] },
                    { title:'通報相關單位', content:[] }
                ]
                advanced_steps = []
                break;
            case '海域安全情境':
                steps = [
                    { title:'查看「<b id="open_typhoon_tide"><a href="#tide_anchor">預警監控_颱風動向_潮位監測</a></b>」', content: [] },
                    { title:'查看「<b id="open_typhoon_buoy"><a href="#buoy_anchor">預警監控_颱風動向_浮標監測</a></b>」', content:['scenario_content_buoy'] },
                    { title:'查看「<b id="open_cctv">預警監控_CCTV</b>」', content:[] },
                    { title:'通報相關單位', content:[] }
                ]
                advanced_steps = []
                break;
            case '維生管線情境':
                steps = [
                    { title:'查看「<b id="open_cctv">預警監控_CCTV</b>」', content:[] },
                    { title:'查看「<b id="open_pipeline_manhole_gas">維生管線_瓦斯管線_瓦斯孔蓋</b>」', content: [] },
                    { title:'查看「<b id="open_pipeline_telecom">維生管線_電信管線</b>」', content:[] },
                    { title:'查看「<b id="open_pipeline_water">維生管線_自來水管線</b>」', content:[] },
                    { title:'查看「<b id="open_pipeline_oil">維生管線_輸油管線</b>」', content:[] },
                    { title:'通報相關單位', content:[] }
                ]
                advanced_steps = []
                break;
        }
        
        for (let [index, step] of steps.entries()) {
            $('#scenario_content').append(
                '<div class="d-flex align-items-start">' +
                    '<div class="rounded-circle" style="margin:6px; width:12px; height:12px; background-color:rgb(104, 143, 180);"></div>' +
                    `<div>STEP${index+1}：${step.title}</div>` +
                '</div>' +
                '<div class="d-flex align-items-stretch">' +
                    '<div style="margin-left:9px; width:6px; background-color:rgb(104, 143, 180);"></div>' +
                    '<div class="p-2 pl-4">' +	
                        '<div id=' + step.content[0] + '></div>' + '<div id=' + step.content[1] + '></div>' + 
                        '<div id=' + step.content[2] + '></div>' + '<div id=' + step.content[3] + '></div>' +
                    '</div>' +
                '</div>'
            ) 
        }
        $('#scenario_content').append(
            '<div>' +
                '<div style="width: 0; height: 0; border-left: 10px solid transparent; margin-left:1.5px; border-right: 10px solid transparent;border-top: 10px solid rgb(104, 143, 180);"></div>' +
            '</div>' 
        )
        if (advanced_steps.length > 0) {
            $('#scenario_content').append(
                '<div class="my-2 d-flex align-items-center">'+
                    '<span class="font-weight-bold text-lg mr-2">進階流程</span>'+
                    '<button type="button" class="close" aria-label="Open">' +
                        '<span id="scenario_content_advanced_show" aria-hidden="true" style="font-size: 30px">&plus;</span>' +
                    '</button>' +
                    '<button type="button" class="close" aria-label="Close">' +
                        '<span id="scenario_content_advanced_hide" aria-hidden="true" style="font-size: 30px" class="d-none">&minus;</span>' +
                    '</button>' +
                '</div>' + 
                '<div id="scenario_content_advanced" class="d-none"></div>')
            
            $('#scenario_content_advanced_show').click(() => {
                $('#scenario_content_advanced_show').addClass('d-none')
                $('#scenario_content_advanced_hide').removeClass('d-none')
                $('#scenario_content_advanced').removeClass('d-none')
            })
            $('#scenario_content_advanced_hide').click(() => {
                $('#scenario_content_advanced_hide').addClass('d-none')
                $('#scenario_content_advanced_show').removeClass('d-none')
                $('#scenario_content_advanced').addClass('d-none')
            })	
            
            for (let [index, step] of advanced_steps.entries()) {
                $('#scenario_content_advanced').append(
                    '<div class="d-flex align-items-start">' +
                        '<div class="rounded-circle" style="margin:6px; width:12px; height:12px; background-color:rgb(104, 143, 180);"></div>' +
                        `<div>${step.title}</div>` +
                    '</div>' +
                    '<div class="d-flex align-items-stretch">' +
                        '<div style="margin-left:9px; width:6px; background-color:rgb(104, 143, 180);"></div>' +
                        '<div class="p-2 pl-4">' +	
                            // '<div id=' + step.content[0] + '></div>' + '<div id=' + step.content[1] + '></div>' + '<div id=' + step.content[2] + '></div>' +
                        '</div>' +
                    '</div>'
                ) 
            }
            $('#scenario_content_advanced').append(
                '<div>' +
                    '<div style="width: 0; height: 0; border-left: 10px solid transparent; margin-left:1.5px; border-right: 10px solid transparent;border-top: 10px solid rgb(104, 143, 180);"></div>' +
                '</div>' 
            )
        }
    }
    if ($("#select_scenario_type").val()) {
        make_scenario_content()
        $('#scenario_content').dialog({
            width: 420,
            title: '建議操作流程',
        }).parent('.ui-dialog').addClass('scale-up')
    }
    if ($("#select_scenario_type").val() == '地震情境') {
        topic_earthquake(true)
    }

    $("#scenario_content").prev(".ui-dialog-titlebar").append(
        '<div style="position:absolute; right: 10px; top: 3px" id="scenario_switch">' +
            '<button type="button" class="close" aria-label="Close">' +
                '<span id="scenario_hide" aria-hidden="true" style="font-size: 30px">&minus;</span>' +
            '</button>' +
        '</div>'
    )

    $("#scenario_hide").click(() => { 
        $('#scenario_content').parent('.ui-dialog').addClass('d-none')
        $("#toggle_scenario_modal").addClass("bg-danger")
    })

    // scenario modal toggle
    $("#toggle_scenario_modal").click(() => {
        $('#scenario_content').parent('.ui-dialog').hasClass('d-none') ? 
            $('#scenario_content').parent('.ui-dialog').removeClass('d-none') : 
            $('#scenario_content').parent('.ui-dialog').addClass('d-none')
    })

    // scenario connects to watches
    let scenario_connects = [
        {ref: "#open_typhoon", target: "#t_typhoon"},
        {ref: "#open_cctv", target: "#t_cctv"},
        {ref: "#open_rain", target: "#t_rain"},
        {ref: "#open_alarm", target: "#t_alarm"},
        {ref: "#open_alarm_debris", target: "#t_alarm_debris"},
        {ref: "#open_debris", target: "#t_hillslope_community"},
        {ref: "#open_earthquake", target: "#t_earthquake"},
        {ref: "#open_fire", target: "#t_fire_report"},
        {ref: "#open_water", target: "#eoc-advice-trig"},
        {ref: "#open_key_analysis", target: "#t_earthquake_ncdr"},
        {ref: "#open_1click", target: "#t_earthquake_1click"},
        {ref: "#open_typhoon_tide", target: "#t_typhoon"},
        {ref: "#open_typhoon_buoy", target: "#t_typhoon"},
        {ref: "#open_pipeline_manhole_gas", target: "瓦斯管線與孔蓋"},
        {ref: "#open_manhole_gas", target: "瓦斯孔蓋"},
        {ref: "#open_pipeline_telecom", target: "電信管線"},
        {ref: "#open_pipeline_water", target: "自來水管線"},
        {ref: "#open_pipeline_oil", target: "輸油管線"},
    ]
    for (let connect of scenario_connects) {
        $(connect.ref).on('click', () => { 
            if (connect.ref.includes('pipeline') || connect.ref.includes('manhole')) {               
			    $("#map_clear").click();
                if (connect.target == "瓦斯管線與孔蓋") {
                    backgroud_layer_control("瓦斯管線")
                    backgroud_layer_control("瓦斯孔蓋")
                } else {
                    backgroud_layer_control(connect.target);
                }
            } else { 
                disable_map_clear = true
                $(connect.target).click()
            } 
        })
    }
    let scenario_advanced_connects = [
        {ref: "#open_rain_predict", target: "ai_rain"},
        {ref: "#open_thundershower_predict", target: "afternoon_rain"},
        {ref: "#open_flood_predict", target: "roadflood"},
        {ref: "#open_hillslope_predict", target: "hillslope"},
        {ref: "#open_power_failure_map", target: "electricity"},
    ]
    for (let connect of scenario_advanced_connects) {
        $(connect.ref).on('click', () => { 
            $("#main-3").click(); prediction_roadflood();
            setTimeout(() => {
                $('#prediction_type').val(connect.target)
                $('#prediction_' + connect.target).siblings().addClass('d-none')
                $('#prediction_info').removeClass('d-none')
                $('#prediction_' + connect.target).removeClass('d-none')
            }, 100) 
        })
    }

    if ($("#select_scenario_type").val()) {
        $('#toggle_scenario_modal').removeClass('d-none')
        $('#scenario_content').removeClass('d-none')
    } else {
        $('#toggle_scenario_modal').addClass('d-none')
        $('#scenario_content').addClass('d-none')
    }
    
    $('#menu').modal('hide')
    emisBtnList.forEach(function(each){
        $('#' + each).attr('disabled', false)
    })

    emis_event_select = true
    raw_data["emisProjectEarthquakeGridLayer"] = false
    loader_asynchronous(function(){
        if (event_updater != undefined) {
            clearInterval(event_updater);
            clearInterval(board_updater);
        }
        $("#right").click();
        var project_name = $("#project_name_list").children(".active").find('span').html()
        // 	project_name_slice = project_name.search("新北市")
        // if (project_name_slice != -1) {
        // 	project_name = project_name.slice(0, project_name_slice);
        // }
        var open_level = null_Converter_v2($("#project_name_list").children(".active").find('span').attr('level')),
            open_or_close = null_Converter_v2($("#project_name_list").children(".active").find('span').attr('status'));
        var scenario_type = $("#select_scenario_type").val() ?? '未選擇'

        $('#panel_subtitle').html('專案名稱：<span id="now_project_name">' + (project_name || '未選擇') + "</span>" + open_level + "級應變" + open_or_close);
        $("#siderbar_subtitle").html(
            "專案名稱：" + (project_name || '未選擇') + "<br>" + 
            "開設層級：" + open_level + "&nbsp;&nbsp;&nbsp;&nbsp;開設狀態：" + open_or_close + "<br>" +
            "災害情境：" + scenario_type
        );

        if ($("#project_name_list").text() == '') {
            $("#map_clear").click();
            overlay_dataset["重大災情"] = undefined
            overlay_dataset["一般災情"] = undefined
            emis_event_select = false
            board_make_conditon = false
            $('#sta-3').html(
                '<div class="card-body">' +
                    '<div id="event_update_div">' +
                        '<div class="text-center m-3">無任何災情顯示，如欲查看災情內容，請於專案選單點選擇專案。<br><br>' +
                            '此按鈕位於系統右下角位置「<img src="topic_icon/control_selector/project_select.png" width="32" alt="">」。'+
                        '</div>' +
                    '</div>' +
                    '<div id="event_plot_div"></div>' +
                    '<div id="event_info_div"></div>' +
                '</div>'
            )
            unSelectedProjectboard()
            $('#scenario_content').find('div').eq(0).find('b').click()
            return
        } else {
            var project_id_query = $("#project_name_list").children(".active").attr('href'), 
                project_id_type = $("#project_description").children(".active").children('.eoc_type')
            project_id_query = project_id_query.slice(1, project_id_query.length);

            raw_data['selected_project_id'] = project_id_query
            raw_data['selected_project_type'] = project_id_type.text()
            var url = publicPath + '/napi/emis/event?project_id=' + project_id_query + '&type=' + project_id_type.text()
            
            $("#event_plot_div").html(
                '<h5 class="font-weight-bold mt-1"><i class="fas fa-map-marker-alt"></i>災情斑點圖展示類型切換</h5>'+
                '<div class="btn-group btn-group-toggle" data-toggle="buttons">'+
                    '<label class="btn btn-secondary btn-sm">'+
                        '<input type="radio" name="options" value="cluster" autocomplete="off" checked>群聚地圖'+
                    '</label>'+
                    '<label class="btn btn-secondary btn-sm">'+
                        '<input type="radio" name="options" value="heatmap" autocomplete="off">熱度圖'+
                    '</label>'+
                    '<label class="btn btn-secondary btn-sm active">'+
                        '<input type="radio" name="options" value="normal" autocomplete="off">點位圖'+
                    '</label>'+
                '</div>'
            );	

            board_make(project_id_query);
            initial_panel(url, project_id_query);
            console.log(project_id_type)
            $("#t_initial").click();

            $('#event_update_div').html(`
                <h4 class="m-0 font-weight-bold">
                    <label class="label-switch switch-danger mr-2 mb-0 vertical-text-top">
                        <input type="checkbox" class="switch switch-bootstrap status" id="event_update_controler" checked="checked"> 
                        <span class="lable"></span>
                    </label>
                    災情自動更新
                </h4>`
                );
            $("#event_update_controler").change(function(){
                var logical = $(this).prop("checked");
                if (logical) {
                    initial_panel(url, project_id_query);
                    event_updater = setInterval(event_updater_control, 1000);
                } else {
                    clearInterval(event_updater);
                }
            });

            // 更新機制
            event_updater = setInterval(event_updater_control, 1000);

            function initial_panel(url, project_id_query){
                raw_data["event"] = ajax_call(url);
                raw_data["event"] = event_raw_geojson(raw_data["event"], project_id_query, project_id_type);		

                var type = $("#event_plot_div .active").find("input").val();
                create_event_map(raw_data["event"], type);
                $("#event_plot_div .btn-secondary").unbind();
                $("#event_plot_div .btn-secondary").click(function(){
                    var type = $(this).find("input").val();
                    loader_asynchronous(function(){
                        create_event_map(raw_data["event"], type);
                    });
                });
            }

            function event_updater_control(){
                var now_time_object = new Date();
                var min = now_time_object.getMinutes();
                var sec = now_time_object.getSeconds();
                var min_logical =  (min % 5 == 0)
                var sec_logical =  (sec == 0)
                if (min_logical && sec_logical) {
                    loader_asynchronous(function(){
                        map.removeLayer(overlay_dataset["重大災情"]);
                        map.removeLayer(overlay_dataset["一般災情"]);
                        var table = $('#event_sta_list').DataTable();
                        table.destroy();
                        initial_panel(url, project_id_query);
                    });
                }
            }

            // board
            board_info_initial(project_id_query);
            board_updater = setInterval(function(){ board_updater_control(project_id_query) }, 1000);
            
            // 地震先期評估專案
            if (project_id_type == "地震") {
                toast_open("地震初期評估震度資料載入中...")
                setTimeout(function(){
                    loader_asynchronous(function(){
                        console.log(project_name)
                        var thisEarthquakeName = project_name.replace("地震初期巡檢", ""),
                            thisEarthquakeInfo,
                            earthQuakeEvalutionEventList
                        if (thisEarthquakeName.match("山腳斷層")) {
                            earthQuakeEvalutionEventList = ajax_call(publicPath + '/napi/simulate/earthquakencdr?event=simulation')
                        } else {
                            earthQuakeEvalutionEventList = ajax_call(publicPath + '/napi/simulate/earthquakencdr')
                            thisEarthquakeName = "Eq" + thisEarthquakeName.slice(0,4) + thisEarthquakeName.slice(5,7) + thisEarthquakeName.slice(8,10) + "_" + thisEarthquakeName.slice(11,13) + thisEarthquakeName.slice(14,16)
                        }
                        thisEarthquakeInfo = earthQuakeEvalutionEventList.filter(function(element){
                            return element.event_id == thisEarthquakeName
                        })
                        if (thisEarthquakeInfo.length > 0) {
                            raw_data["emisProjectEarthquakeGridLayer"] = earthquake_alert_ncdr(thisEarthquakeInfo[0])
                        }
                        $("#t_initial").click()
                    })
                }, 1000)
            }

            $("#main-2").click()
        }
        if ($('#select_project_type').val() == 'ALL') { $('#select_scenario_type').val("ALL") }
    })
}

// project unselected submit
function unSelectedProjectboard(){
    if (!emis_event_select && !board_make_conditon) {
        board_make_conditon = true
        board_make()
        board_info_initial()
        board_updater = setInterval(function(){ board_updater_control() }, 1000);
    }
}